import React from "react";
import DOMPurify from "dompurify";
import DataTempoPipe from "../../../vendors/pipe/DataTempoPipe";
import SafeHtml from "../safe-html";
import { InformeEvento } from "../../shared/@types/informeEvento";
import "./index.scss";

interface Props {
  informe: InformeEvento;
  onClick?: () => void;
  modo?: "resumo" | "completo";
}

function textoSemHtml(str: string) {
  return DOMPurify.sanitize(str || "", { ALLOWED_TAGS: [] });
}

function Vigencia({ informe }: { informe: InformeEvento }) {
  return (
    <span className="informe-card-data">
      Vigência: <DataTempoPipe value={informe.dtInicioInforme} /> até{" "}
      <DataTempoPipe value={informe.dtFimInforme} />
    </span>
  );
}

export default function InformeCard({
  informe,
  onClick,
  modo = "completo",
}: Props) {
  const resumo = modo === "resumo";

  const conteudo = (
    <>
      <div className="informe-card-icone">
        <i className="pi pi-exclamation-triangle" />
      </div>
      <div className="informe-card-conteudo">
        <h4 className="informe-card-titulo">{informe.noInforme}</h4>
        {resumo ? (
          <>
            <p className="informe-card-descricao informe-card-descricao--clamp">
              {textoSemHtml(informe.dsInforme)}
            </p>
            <Vigencia informe={informe} />
          </>
        ) : (
          <>
            <Vigencia informe={informe} />
            <SafeHtml
              className="informe-card-descricao"
              html={informe.dsInforme || ""}
            />
          </>
        )}
      </div>
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        className="informe-card informe-card--clicavel"
        onClick={onClick}
      >
        {conteudo}
      </button>
    );
  }

  return <div className="informe-card">{conteudo}</div>;
}
